export * from './piece-jointe.model';



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/piece-jointe/index.ts